<!--
 * @Descripttion: 带table列表的抽屉模板
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2023-01-17 22:08:03
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-27 14:55:00
-->
<template>
	<div>
		<el-drawer
			:title="title"
			:visible.sync="visible"
			:append-to-body="appendToBody"
			:size="size"
			:before-close="handleClose"
			:wrapperClosable="wrapperClosable"
			custom-class="drawer-template"
		>
			<div class="content">
				<div class="tips radius-4 mb-24">
					<i class="el-icon-info yx-color-primary"></i>
					<span class="yx-color-pure-1 font-h4-regular ml-10">集合页中仅展示商品组中的有效商品</span>
				</div>
				<div class="pos-rela ml-12 flex-1">
					<el-input placeholder="请输入商品组名称" v-model="form.group_name" clearable></el-input>
					<el-button class="searchBtn" @click="search()">搜索</el-button>
				</div>
				<!-- 弹窗内容部分 -->
				<el-table
					class="mt-24"
					:data="list"
					header-row-class-name="table-header-row"
					row-class-name="table-row"
					v-loading="loading"
					@row-click="rowClick"
				>
					<el-table-column label="商品组名称" prop="partner_commission_fee">
						<template slot-scope="{ row }">
							<div class="flex flex-align-center">
								<el-radio v-model="id" :label="row.id">{{ '' }}</el-radio>
								<div>
									<el-tooltip placement="top" :content="row.group_name" v-ak-tooltip-auto-show>
										<p class="line-ellipsis-1 yx-color-pure-1 font-h4-regular" style="width: 100%">{{ row.group_name }} </p>
									</el-tooltip>
									<p class="yx-color-pure-1 font-h6-medium">ID：{{ row.id }}</p>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="商品数量" prop="partner_commission_fee" width="130">
						<template slot-scope="{ row }">
							<span class="yx-color-pure-1 font-h6-regular">{{ row.product_num }}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="100px" prop="operates">
						<template slot-scope="{ row }">
							<el-button type="text" @click.stop="skipGroup(row)">查看详情</el-button>
						</template>
					</el-table-column>
				</el-table>
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page_index"
					:page-size="pageInfo.page_size"
					@size-change="sizeChange"
					@current-change="currentChange"
				></yx-pagination>
			</div>
			<div class="drawer-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirm" :loading="btnLoading">确认</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import { groupList } from '@/api/shopManage';
export default {
	props: {
		size: {
			type: Number,
			default: 800,
		},
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	computed: {},
	data() {
		return {
			title: '选择商品组', // 弹窗标题
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			total: 0, // 列表总数
			pageInfo: {
				page_index: 1, // 页码
				page_size: 20, // 每页条数
			},
			form: {
				group_name: '',
			},
			loading: false, // 表格加载状态
			btnLoading: false, // 按钮loading
			id: 0,
		};
	},

	created() {
		this.initData();
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(id = 0) {
			this.id = id;
			this.visible = true;
			this.getList();
		},
		//获取商品组列表
		async getList() {
			this.loading = true;
			const { platformId: platform_id } = this;
			const { code, data: { list = [], page = {} } = {} } = await groupList({ ...this.pageInfo, ...this.form, platform_id });
			this.loading = false;
			if (code !== 0) return;
			this.list = list;
			this.total = `${page.item_total}`;
		},

		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.total = 0;
			this.id = 0;
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			this.form = {
				group_name: '',
			};
			this.loading = false;
			this.btnLoading = false;
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm() {
			// 按钮loading开启
			this.btnLoading = true;
			try {
				// 刷新列表（外部重新获取数据）
				const data = this.list.find(item => item.id === this.id);
				const { group_name: groupTitle, id: link } = data;
				this.$emit('confirmAddGoodsGroup', { groupTitle, link });
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading开启
				this.btnLoading = false;
			}
		},
		// 每页展示条数变化
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.getList();
		},
		// 页数变化
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.getList();
		},
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 抽屉是否添加到body节点下
			this.appendToBody = true;
			// 点击蒙版是否关闭
			this.wrapperClosable = false;
		},
		openPreview() {
			this.$refs.previewImg.show();
		},
		skipGroup({ id }) {
			const { platformId } = this;
			const handLink = this.$router.resolve({
				path: '/shopManage/shopGroup/detail/list',
				query: {
					groupId: id,
					platformId,
				},
			});
			window.open(handLink.href, '_blank');
		},
		rowClick({ id }) {
			this.id = id;
		},
		search() {
			this.getList();
		},
	},
	beforeDestroy() {},
};
</script>
<style lang="less" scoped>
.content {
	.tips {
		padding: 8px 16px;
		border: 1px solid #5091ff;
		background: #f0f5ff;
	}

	.searchBtn {
		width: 70px;
		background-color: @color-primary;
		color: #ffffff;
		font-size: 13px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid @color-primary;
	}

	::v-deep .el-radio {
		margin-right: 10px;
	}
}

.drawer-footer {
	background-color: #fff;
	z-index: 999;
}
</style>
